import axios from 'axios';
import { getHydratedContent } from './crepo';
import { setAuthHeader } from 'Services/utils';
const FAVORITES_API_URL = process.env.REACT_APP_ACTIONS_API_URL;
let favoritesCT;

const setUserFavoritesApiUrl = (userId) => {
  return `${FAVORITES_API_URL}/v2/actions/com/users/${userId}/favorites`;
};

const getUserFavoritesById = async ({
  cancelToken,
  filterBy,
  interestsBased = false,
  limit = 20,
  offset = 0,
  userId,
  userToken,
}) => {
  let request = `${setUserFavoritesApiUrl(
    userId
  )}?limit=${limit}&offset=${offset}`;
  if (!interestsBased) {
    request += `&filterBy=${filterBy}`;
  }
  const { data } = await axios.get(request, {
    cancelToken,
    ...setAuthHeader(userToken),
  });
  const { items, meta } = data;
  return {
    ids: Object.keys(items),
    total: meta.total,
    totalCount: meta.totalCount,
  };
};

const getUserFavorites = async ({
  cancelPreviousReq,
  interestsBased = false,
  limit = 20,
  locale,
  offset = 0,
  type,
  userId,
  userToken,
}) => {
  // If necessary (such as when changing library tabs), cancel the previous request before making a new request
  favoritesCT && cancelPreviousReq && favoritesCT.cancel();
  // Create a new CancelToken
  favoritesCT = axios.CancelToken.source();

  try {
    const { ids, total, totalCount } = await getUserFavoritesById({
      cancelToken: favoritesCT.token,
      filterBy: type.toLowerCase(),
      interestsBased,
      limit,
      offset,
      userId,
      userToken,
    });

    if (!total)
      return {
        expectedResourceCount: 0,
        expectedTotalCount: totalCount,
        resourceCount: 0,
        resources: [],
      };

    const resources = await getHydratedContent({
      cancelToken: favoritesCT.token,
      locale,
      ids: ids.map((id) => `"${id}"`),
    });

    return {
      expectedResourceCount: total,
      expectedTotalCount: totalCount,
      resourceCount: resources.length,
      resources,
    };
  } catch (err) {
    // Ignore error from canceled request
    const isCancel = axios.isCancel(err);
    // No user favorites returns 404
    const noFavorites =
      err instanceof Error && err.response && err.response.status === 404;
    if (isCancel || noFavorites)
      return {
        expectedResourceCount: 0,
        expectedTotalCount: 0,
        isCancel,
        resourceCount: 0,
        resources: [],
      };
    throw err;
  }
};

const addUserFavorite = ({ contentId, userId, userToken }) => {
  return axios.post(
    `${setUserFavoritesApiUrl(userId)}/${encodeURIComponent(contentId)}`,
    null,
    { ...setAuthHeader(userToken) }
  );
};

const deleteUserFavorite = ({ contentId, userId, userToken }) => {
  return axios.delete(
    `${setUserFavoritesApiUrl(userId)}/${encodeURIComponent(contentId)}`,
    { ...setAuthHeader(userToken) }
  );
};

export {
  getUserFavoritesById,
  getUserFavorites,
  addUserFavorite,
  deleteUserFavorite,
};
